import ProductTransformer from './ProductTransformer';

export default class ProductOrderConfirmationOptinTransformer extends ProductTransformer {
  static fetch(product, footnotes) {
    product = super.fetch(product, footnotes);

    const expression = new RegExp('optin', 'i');
    product = super.removeExpFromName(product, expression);

    return product;
  }

  static addFootnote(fn, product) {
    if (fn.name === 'footNoteOptinConfirmation') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    ['productOptinConfirmation', 'productOptinConfirmationBeforeButtons', 'productOptinConfirmationAfterButtons'].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
